import { SvgIconProp } from "../../../../types";

export const StopIcon = (props: SvgIconProp) => {
  return (
      <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.50065 17.4167C5.12839 17.4167 1.58398 13.8723 1.58398 9.50004C1.58398 5.12778 5.12839 1.58337 9.50065 1.58337C13.8729 1.58337 17.4173 5.12778 17.4173 9.50004C17.4173 13.8723 13.8729 17.4167 9.50065 17.4167ZM9.50065 15.8334C12.9985 15.8334 15.834 12.9979 15.834 9.50004C15.834 6.00224 12.9985 3.16671 9.50065 3.16671C6.00285 3.16671 3.16732 6.00224 3.16732 9.50004C3.16732 12.9979 6.00285 15.8334 9.50065 15.8334ZM7.12565 7.12504H11.8757V11.875H7.12565V7.12504Z" fill="#ED2A2A" />
      </svg>
  );
};